/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPinS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m10.331 4.289 3.129-3.177 8.298 8.298-3.187 3.15-2.062-.668-2.763 2.8v4.031l-2.378 2.406-4.11-4.11-4.082 4.083-1.414-1.415 4.082-4.082-4.097-4.097 2.328-2.383H8.21l2.775-2.75z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPinS as PinS };
